import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConfigurationService, CustomerService, DebtorService, InvoicesService } from '../_services';
import { AppConfig } from '../_helpers/index';
import * as XLSX from 'xlsx';
import * as Excel from "exceljs/dist/exceljs.min.js";
import { AccountImport } from '../_models';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { ICustomer, IAddress } from '../_models/customer.interface';
import { Debtor } from '../_models/index';
import * as fs from 'file-saver';

@Component({
    selector: 'paymentcustomerimportv1',
    templateUrl: './paymentcustomerimportv1.component.html',
    styleUrls: ['../invoices/payout-invoice-import-process/old-payout-invoice-import-version/old-payout-invoice-import-version.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class PaymentCustomerImportComponentv1 implements OnInit {
    uploadedFileName: any;
    tab1ActiveStatus: any;
    tab2ActiveStatus: any;
    tab3ActiveStatus: any;
    tab1Visibility: any;
    tab2Visibility: any;
    tab3Visibility: any;
    customerPuplic_key: any;
    user_public_id: any;
    offsetTimeZone: any;
    offsetMinutes: any;
    offsetTimeVal: any;
    userNameProcess: string;
    userEmail: string;
    searchFilterForm: FormGroup;
    enableImportExcel: boolean;
    data = [];
    errorImport: string;
    excelHeader: any;
    excelheaderFormat = ['ID CLIENTE', 'DOCUMENTO', 'NUMERO DOCUMENTO', 'NOMBRE', 'EMAIL', 'TELEFONO', 'ESTADO', 'CALLE', 'PROVINCIA', 'CIUDAD', 'DISTRITO'];
    hiddenRow = [];
    hiddenRowCount = 0;
    hiddenColumn = [];
    hiddenColumnCount = 0;
    excelColumnNameAndLetter = [];
    excelAvailableColumn = [];
    missingExcelColumns = [];
    excelInvalidColumn = [];
    excelInvalidColumnLetter = [];
    keyValuesChange = {
        'ITEM': "item",
        'ID CLIENTE': 'external_id',
        'DOCUMENTO': 'document_type',
        'NUMERO DOCUMENTO': 'document_id',
        'NOMBRE': 'name',
        'EMAIL': 'email',
        'TELEFONO': 'phone',
        'ESTADO': 'status',
        'CALLE': 'street',
        'PROVINCIA': 'provice',
        'CIUDAD': 'city',
        'DISTRITO': 'district',
    };
    keyChangedData = [];
    arrFinalData = [];
    @ViewChild('customerPaginator', { read: MatPaginator }) customerPaginator: MatPaginator;
    @ViewChild('customerPaginator1', { read: MatPaginator }) customerPaginator1: MatPaginator;
    excelRowsFetchedCount: any;
    excelRowsProcessedCount: any;
    excelRowsNotProcessedCount: any;
    dataSource: any;
    pageSize: number;
    PageSizeOptions: number[];
    displayedColumns: string[] = ['item', 'external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district'];
    tab3Error: boolean;
    columnErrorCount = 0;
    rowErrorCount = 0;
    invalidDataArray: any;
    validDataArray: any;
    invalidDataSource: any;
    obsInvalidData: Observable<any>;
    customerList = [];
    rowNotProcessedCount = 0;
    rowProcessedCount = 0;
    arrFinalDataWithStatus = [];
    tempExcelHeader = [];

    baseURL: string;

    constructor(private router: Router, private formBuilder: FormBuilder
        , private spinnerService: Ng4LoadingSpinnerService
        , private excelService: ExcelService
        , private customerService: CustomerService
        , private debtorService: DebtorService) {
        this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
        this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
        this.baseURL = AppConfig.settings.apiServer.baseURL+'processes/processimport';
    }

    ngOnInit() {
        var tempBrowserStorage;

        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customerPuplic_key = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');
                this.userNameProcess = localStorage.getItem('username');
                this.userEmail = localStorage.getItem('userEmail');
            }
        }
        else {
            this.customerPuplic_key = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }

        tempBrowserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
        this.offsetTimeZone = (typeof tempBrowserStorage.getItem('timezone') === 'undefined') ? null : tempBrowserStorage.getItem('timezone');
        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

            this.offsetTimeZone = -5.00;
            this.offsetMinutes = 0;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }
        else {

            this.offsetTimeZone = tempBrowserStorage.getItem('timezone');
            this.offsetMinutes = 0;

            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }
        this.InitialSetup();
    }

    downloadSampleFile() {
        var url = 'assets/helpfiles/CustomerImport.xlsx?v=' + moment(new Date()).format('YYYYMMDDHHmm');
        var fileName = "CustomerImport.xlsx";
        // location.href = 'assets/helpfiles/CustomerImport.xlsx?v='+ moment(new Date()).format('YYYYMMDDHHmm');
        this.customerService.downloadTemplatefile(url).subscribe(res => {
            var blob = new Blob([res.body], { type: res.body.type });
            const file = new File([blob], fileName, { type: res.body.type });
            fs.saveAs(file);
        },
            error => {
                console.log('Failed while trying to the download the file. ' + error.error);
            })
    }

    ngAfterViewInit() {
        this.customerPaginator._intl.itemsPerPageLabel = "Registros por página";
        this.customerPaginator._intl.nextPageLabel = "siguiente página";
        this.customerPaginator._intl.lastPageLabel = "última página";
        this.customerPaginator._intl.previousPageLabel = "anterior página";
        this.customerPaginator._intl.firstPageLabel = "primera página";

        this.customerPaginator1._intl.itemsPerPageLabel = "Registros por página";
        this.customerPaginator1._intl.nextPageLabel = "siguiente página";
        this.customerPaginator1._intl.lastPageLabel = "última página";
        this.customerPaginator1._intl.previousPageLabel = "anterior página";
        this.customerPaginator1._intl.firstPageLabel = "primera página";
    }

    InitialSetup() {
        this.tab1();
        this.dataSource = new MatTableDataSource();
        this.tab3Error = false;
    }

    tab1() {
        this.searchFilterForm = this.formBuilder.group({
            edt: ['']
        });
        this.enableImportExcel = false;
        this.tab1ActiveStatus = "active";
        this.tab2ActiveStatus = "disabled";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = true;
        this.uploadedFileName = "Archivo a subir";
        window.scroll(0, 0);
        this.InitFileChange();
    }

    tab2() {
        this.tab1Visibility = true;
        this.tab2Visibility = false;
        this.tab3Visibility = true;
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        window.scroll(0, 0);
    }

    tab3() {
        this.tab1Visibility = true;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "disabled";
        this.tab3ActiveStatus = "active";
        window.scroll(0, 0);
    }

    Executeagain() {
        this.InitialSetup();
    }


    InitFileChange() {
        this.data = [];
        this.hiddenRow = [];
        this.hiddenRowCount = 0;
        this.hiddenColumn = [];
        this.hiddenColumnCount = 0;
        this.excelColumnNameAndLetter = [];
        this.excelAvailableColumn = [];
        this.missingExcelColumns = [];
        this.excelInvalidColumn = [];
        this.excelInvalidColumnLetter = [];
        this.arrFinalData = [];
        this.keyChangedData = [];
        this.columnErrorCount = 0;
        this.rowErrorCount = 0;
        this.invalidDataArray = [];
        this.validDataArray = [];
        this.invalidDataSource = new MatTableDataSource();
        this.excelRowsFetchedCount = Number(0);
        this.excelRowsProcessedCount = Number(0);
        this.excelRowsNotProcessedCount = Number(0);
        this.excelHeader = [];
        this.obsInvalidData = this.invalidDataSource.connect();
        this.rowNotProcessedCount = 0;
        this.rowProcessedCount = 0;
        this.arrFinalDataWithStatus = [];
        this.tempExcelHeader = [];
    }

    OnFileChange(evt: any) {
        this.InitFileChange();
        let jsonData = null;
        let workBook = null;
        let sheet = [];
        /* wire up file reader */
        const target: DataTransfer = <DataTransfer>(evt.target);
        if (target.files.length > 1) throw new Error('Cannot use multiple files');
        if (target.files.length === 1) {
            this.checkHiddenRowAndColumns(target.files[0]);
            const file = target.files[0];
            this.searchFilterForm.get('edt').setValue(file);
            this.uploadedFileName = target.files[0].name;

            if (target.files.length == 1 && (target.files[0].type == ".xlsx" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) {
                const reader: FileReader = new FileReader();
                reader.onload = (e: any) => {
                    const data = reader.result;
                    workBook = XLSX.read(data, { type: 'binary' });
                    jsonData = workBook.SheetNames.reduce((initial, name) => {
                        const sheet = workBook.Sheets[name];
                        initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false, blankrows: false })
                            .map(row =>
                                Object.keys(row).reduce((obj, key) => {
                                    obj[key.trim()] = row[key];
                                    return obj;
                                }, {})
                            );
                        return initial;
                    }, {});
                    var sheet = Object.keys(jsonData);
                    if (sheet.length > 0) {
                        this.data = jsonData[sheet[0]];
                    } else {
                        this.data = [];
                    }
                    this.enableImportExcel = true;
                };
                reader.readAsBinaryString(target.files[0]);
            }
            else {
                this.enableImportExcel = false;
                this.errorImport = "Error al intentar abrir el archivo ! ";
            }
        } else {
            this.uploadedFileName = "Archivo a subir";
        }
    }

    checkHiddenRowAndColumns(file) {
        const workbook = new Excel.Workbook();
        const arryBuffer = new Response(file).arrayBuffer();

        arryBuffer.then((data) => {
            workbook.xlsx.load(data)
                .then(() => {
                    const worksheet = workbook.getWorksheet(1);
                    //this.spinnerService.hide();
                    var name;
                    var k = 0;
                    //check hidden columns
                    for (var i = 0; i < worksheet.columns.length; i++) {
                        if (worksheet.columns[i].hidden == true) {
                            this.hiddenColumn.push(worksheet.columns[i].letter);
                            this.hiddenColumnCount++;
                        }
                        if (worksheet.columns[i].values.length > 0) {
                            name = worksheet.columns[i].values[1];
                        } else {
                            //for empty header
                            if (k == 0) {
                                name = "__EMPTY";
                                k++;
                            }
                            else if (k > 0) {
                                name = "__EMPTY_" + k;
                                k++;
                            }
                        }
                        if (!name.includes("__EMPTY")) {
                            this.excelColumnNameAndLetter.push(
                                {
                                    "letter": worksheet.columns[i].letter,
                                    "name": name,
                                    "hidden": worksheet.columns[i].hidden
                                }
                            );
                        }
                    }

                    //check hidden row
                    worksheet.eachRow((row) => {
                        if (row.hidden == true) {
                            this.hiddenRow.push(row.number);
                            this.hiddenRowCount++;
                        }
                    });

                });
        });
    }

    import() {
        this.spinnerService.show();
        this.enableImportExcel = false;
        this.importExcelData();
    }

    //   check the excel header column format & missing column & invalid column name
    checkExcelHeader() {
        for (var i = 0; i < this.excelheaderFormat.length; i++) {
            for (var j = 0; j < this.excelHeader.length; j++) {
                if (this.excelheaderFormat[i] === this.excelHeader[j]) {
                    this.excelAvailableColumn.push(this.excelheaderFormat[i]);
                }
            }
        }
        this.missingExcelColumns = this.excelheaderFormat.filter(item => this.excelAvailableColumn.indexOf(item) < 0);
        if (this.missingExcelColumns.length == 0) {
            if (this.excelheaderFormat.length !== this.excelHeader.length) {
                this.excelInvalidColumn = this.excelHeader.filter(item => this.excelheaderFormat.indexOf(item) < 0);
            }
        }
    }

    //get the Invalid column excel letter
    getInvalidColumnLetter() {
        let tempValue;
        tempValue = this.excelColumnNameAndLetter.filter(item => this.excelInvalidColumn.some(f => f == item.name));
        tempValue.forEach(element => {
            if (element.hidden == false) {
                this.excelInvalidColumnLetter.push(element.letter)
            }
        });
    }

    importExcelData() {
        //this.excelHeader = Object.keys(this.data[0]);
        this.tempExcelHeader = Object.keys(this.data[0]);
        for (var x = 0; x < this.tempExcelHeader.length; x++) {
            if (!this.tempExcelHeader[x].includes("__EMPTY")) {
                this.excelHeader.push(this.tempExcelHeader[x])
            }
        }
        this.checkExcelHeader()
        this.getInvalidColumnLetter();
        if (this.excelAvailableColumn.length == 11) {
            //add the item column and row number
            var k = 1
            this.data.forEach(element => {
                element['ITEM'] = k;
                k++
            });

            //change the key value
            this.data.forEach(element => {
                let mapped = Object.keys(element).reduce((item, key) => {
                    item[this.keyValuesChange[key]] = element[key];
                    return item;
                }, {});
                this.keyChangedData.push(mapped);
            });

            for (var i = 0; i < this.keyChangedData.length; i++) {
                var object_temp = this.keyChangedData[i];
                var dataError = [];
                var dataInvalidError = [];

                //validate the ID CLIENTE column value
                if (object_temp['external_id'] != '' && object_temp['external_id'] != null && object_temp['external_id'] != undefined) {
                    if (object_temp['external_id'].length > 20) {
                        object_temp['external_id'] = 'Dato inválido';
                        dataInvalidError.push("ID CLIENTE");
                    }
                } else {
                    object_temp['external_id'] = 'Dato inválido';
                    dataError.push("ID CLIENTE");
                }

                //validate the DOCUMENTO column value
                if (object_temp['document_type'] != '' && object_temp['document_type'] != null && object_temp['document_type'] != undefined) {
                    switch (object_temp['document_type'].trim()) {
                        case 'DNI':
                            break;
                        case 'RUC':
                            break;
                        case 'CEX':
                            break;
                        case 'OTROS':
                            break;
                        default:
                            object_temp['document_type'] = 'Dato inválido';
                            dataInvalidError.push("DOCUMENTO")
                    }
                } else {
                    object_temp['document_type'] = 'Dato inválido';
                    dataError.push('DOCUMENTO');
                }

                //validate the NUMERO DOCUMENTO column value
                if (object_temp['document_id'] != '' && object_temp['document_id'] != null && object_temp['document_id'] != undefined) {
                    if (object_temp['document_id'].length > 20) {
                        object_temp['document_id'] = 'Dato inválido';
                        dataInvalidError.push("NUMERO DOCUMENTO");
                    }
                } else {
                    object_temp['document_id'] = 'Dato inválido';
                    dataError.push("NUMERO DOCUMENTO");
                }

                //validate the NOMBRE column value
                if (object_temp['name'] != '' && object_temp['name'] != null && object_temp['name'] != undefined) {
                    if (object_temp['name'].length > 50) {
                        object_temp['name'] = 'Dato inválido';
                        dataInvalidError.push("NOMBRE");
                    }
                    if (!(/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(object_temp['name']))) {
                        object_temp['name'] = 'Dato inválido';
                        dataInvalidError.push("NOMBRE");
                    }
                } else {
                    object_temp['name'] = 'Dato inválido';
                    dataError.push("NOMBRE");
                }

                //validate the EMAIL column value
                if (object_temp['email'] != '' && object_temp['email'] != null && object_temp['email'] != undefined) {
                    if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(object_temp['email'].trim()))) {
                        object_temp['email'] = 'Dato inválido';
                        dataInvalidError.push("EMAIL")
                    }
                } else {
                    object_temp['email'] = 'Dato inválido';
                    dataError.push("EMAIL");
                }

                //validate the TELEFONO column value
                if (object_temp['phone'] != '' && object_temp['phone'] != null && object_temp['phone'] != undefined) {
                    if (object_temp['phone'].length > 20) {
                        object_temp['phone'] = 'Dato inválido';
                        dataInvalidError.push("TELEFONO");
                    }
                } else {
                    object_temp['phone'] = 'Dato inválido';
                    dataError.push("TELEFONO");
                }

                //validate the ESTADO column value
                if (object_temp['status'] != '' && object_temp['status'] != null && object_temp['status'] != undefined) {
                    switch (object_temp['status'].trim()) {
                        case 'ACTIVO':
                            break;
                        case 'INACTIVO':
                            break;
                        default:
                            object_temp['status'] = 'Dato inválido';
                            dataInvalidError.push("ESTADO")
                    }
                } else {
                    object_temp['status'] = 'Dato inválido';
                    dataError.push('ESTADO');
                }

                //validate the CALLE column value
                if (object_temp['street'] != '' && object_temp['street'] != null && object_temp['street'] != undefined) {
                    if (object_temp['street'].length > 50) {
                        object_temp['street'] = 'Dato inválido';
                        dataInvalidError.push("CALLE");
                    }
                    if (!(/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(object_temp['street']))) {
                        object_temp['street'] = 'Dato inválido';
                        dataInvalidError.push("CALLE");
                    }
                } else {
                    object_temp['street'] = 'Dato inválido';
                    dataError.push("CALLE");
                }

                //validate the PROVINCIA column value
                if (object_temp['provice'] != '' && object_temp['provice'] != null && object_temp['provice'] != undefined) {
                    if (object_temp['provice'].length > 50) {
                        object_temp['provice'] = 'Dato inválido';
                        dataInvalidError.push("PROVINCIA");
                    }
                    if (!(/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(object_temp['provice']))) {
                        object_temp['provice'] = 'Dato inválido';
                        dataInvalidError.push("PROVINCIA");
                    }
                } else {
                    object_temp['provice'] = 'Dato inválido';
                    dataError.push("PROVINCIA");
                }

                //validate the CIUDAD column value
                if (object_temp['city'] != '' && object_temp['city'] != null && object_temp['city'] != undefined) {
                    if (object_temp['city'].length > 20) {
                        object_temp['city'] = 'Dato inválido';
                        dataInvalidError.push("CIUDAD");
                    }
                    if (!(/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(object_temp['city']))) {
                        object_temp['city'] = 'Dato inválido';
                        dataInvalidError.push("CIUDAD");
                    }
                } else {
                    object_temp['city'] = 'Dato inválido';
                    dataError.push("CIUDAD");
                }

                //validate the DISTRITO column value
                if (object_temp['district'] != '' && object_temp['district'] != null && object_temp['district'] != undefined) {
                    if (object_temp['district'].length > 50) {
                        object_temp['district'] = 'Dato inválido';
                        dataInvalidError.push("DISTRITO");
                    }
                    if (!(/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(object_temp['district']))) {
                        object_temp['district'] = 'Dato inválido';
                        dataInvalidError.push("DISTRITO");
                    }
                } else {
                    object_temp['district'] = 'Dato inválido';
                    dataError.push("DISTRITO");
                }

                if (dataError.length > 0 && dataError.length < 10) {
                    this.columnErrorCount++;
                }

                if (dataError.length > 10) {
                    this.rowErrorCount++;
                }

                if (dataInvalidError.length > 0) {
                    this.columnErrorCount++;
                }

                object_temp["dataError"] = dataError.length > 10 ? null : dataError;
                object_temp["dataInvalidError"] = dataInvalidError;
                object_temp["rowError"] = dataError.length > 10 ? dataError : null;
                this.arrFinalData.push(object_temp);
            }
            this.checkValidAndInvalidData();
            this.excelRowsFetchedCount = this.arrFinalData.length;
            this.dataSource.paginator = this.customerPaginator;
            this.dataSource.data = this.arrFinalData;
            this.invalidDataSource.data = this.invalidDataArray;
            this.invalidDataSource.paginator = this.customerPaginator1;
            this.obsInvalidData = this.invalidDataSource.connect();
            this.spinnerService.hide();
            this.tab2();
        }
        else {
            this.tab3Error = true;
            this.tab3();
            this.spinnerService.hide();
        }
    }

    ngOnDestroy() {
        if (this.invalidDataSource) {
            this.invalidDataSource.disconnect();
        }
    }

    checkValidAndInvalidData() {
        for (var i = 0; i <= this.arrFinalData.length - 1; i++) {
            var debtorobj = this.arrFinalData[i];
            var exists = Object.keys(debtorobj).some(function (k) {
                return debtorobj[k] === "Dato inválido";
            });
            if (exists == true) {
                this.invalidData(debtorobj);
            } else if (exists == false) {
                this.validData(debtorobj);
            }
        }
    }

    invalidData(data) {
        this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
        this.invalidDataArray.push(data);
    }
    validData(data) {
        this.excelRowsProcessedCount = this.excelRowsProcessedCount + 1;
        this.validDataArray.push(data);
    }

    downloadInvalidExcelResultAsXLSX() {
        this.setValidationExportExcelFileData(this.arrFinalData);
    }

    setValidationExportExcelFileData(excelExportData) {
        var excelHeaders = ['ITEM', 'ID CLIENTE', 'DOCUMENTO', 'NUMERO DOCUMENTO', 'NOMBRE', 'EMAIL', 'TELEFONO', 'ESTADO', 'CALLE', 'PROVINCIA', 'CIUDAD', 'DISTRITO'];

        var arrFinalDatas = [];
        var object_temp = {};
        var i = 0;
        var columnsKeyNames = [];
        for (i = 0; i < excelExportData.length; i++) {
            var singleRec_temp = excelExportData[i];
            columnsKeyNames = Object.keys(singleRec_temp);
            var externalid_temp = "";
            var item_temp = "";
            var document_type_temp = "";
            var document_id_temp = "";
            var name_temp = "";
            var email_temp = "";
            var phone_temp = "";
            var status_temp = "";
            var street_temp = "";
            var provice_temp = "";
            var city_temp = "";
            var district_temp = "";

            for (var j = 0; j < columnsKeyNames.length; j++) {
                if (columnsKeyNames[j] == "item") {
                    item_temp = singleRec_temp[columnsKeyNames[j]];
                }
                else if (columnsKeyNames[j] == "external_id") {
                    externalid_temp = singleRec_temp[columnsKeyNames[j]];
                }
                else if (columnsKeyNames[j] == "document_type") {
                    document_type_temp = singleRec_temp[columnsKeyNames[j]];
                }
                else if (columnsKeyNames[j] == "document_id") {
                    document_id_temp = singleRec_temp[columnsKeyNames[j]];
                }

                else if (columnsKeyNames[j] == "name") {
                    name_temp = singleRec_temp[columnsKeyNames[j]];
                }

                else if (columnsKeyNames[j] == "email") {
                    email_temp = singleRec_temp[columnsKeyNames[j]];
                }

                else if (columnsKeyNames[j] == "phone") {
                    phone_temp = singleRec_temp[columnsKeyNames[j]];
                }

                else if (columnsKeyNames[j] == "status") {
                    status_temp = singleRec_temp[columnsKeyNames[j]];
                }

                else if (columnsKeyNames[j] == "street") {
                    street_temp = singleRec_temp[columnsKeyNames[j]];
                }

                else if (columnsKeyNames[j] == "provice") {
                    provice_temp = singleRec_temp[columnsKeyNames[j]];
                }

                else if (columnsKeyNames[j] == "city") {
                    city_temp = singleRec_temp[columnsKeyNames[j]];
                }
                else if (columnsKeyNames[j] == "district") {
                    district_temp = singleRec_temp[columnsKeyNames[j]];
                }
            }
            arrFinalDatas.push([item_temp, externalid_temp, document_type_temp, document_id_temp, name_temp,
                email_temp, phone_temp, status_temp, street_temp, provice_temp, city_temp, district_temp])
        }
        this.excelService.generateExcelForInvalidData(excelHeaders, arrFinalDatas, "CustomerImportInvalidData")
    }


    confirmData() {
        this.spinnerService.show();
        for (var i = 0; i <= this.arrFinalData.length - 1; i++) {
            var tempDebtorObj = this.arrFinalData[i];
            var exists = Object.keys(tempDebtorObj).some(function (k) {
                return tempDebtorObj[k] === "Dato inválido";
            });
            if (exists == true) {
                this.rowNotProcessedCount++;
                var tempErrorObj = this.arrFinalData[i].dataError.concat(this.arrFinalData[i].dataInvalidError);
                this.bindDebtorDetailsExcelData('NO', tempErrorObj.toString() + " inválido", i);
            } else if (exists == false) {
                this.createDebtor(this.arrFinalData[i], i);
            }


        }//end for
        this.tab3Error = false;
        this.tab3();
    }

    createDebtor(arrFinalData: any, iVal: any) {
        var debtorObj = {} as Debtor;
        var customerObj = {} as ICustomer;
        var addressObj = {} as IAddress;

        debtorObj.document_id = (this.arrFinalData[iVal].document_id === undefined) ? '' : this.arrFinalData[iVal].document_id.toString();
        if (this.arrFinalData[iVal].document_type == 'OTROS' || this.arrFinalData[iVal].document_type == 'OTHER') {
            debtorObj.document_type = "OTHER";
        }
        else {
            debtorObj.document_type = (this.arrFinalData[iVal].document_type === undefined) ? '' : this.arrFinalData[iVal].document_type.toString();
        }

        debtorObj.email = (this.arrFinalData[iVal].email === undefined) ? '' : this.arrFinalData[iVal].email.toString();
        debtorObj.external_id = (this.arrFinalData[iVal].external_id === undefined) ? '' : this.arrFinalData[iVal].external_id.toString();
        debtorObj.name = (this.arrFinalData[iVal].name === undefined) ? '' : this.arrFinalData[iVal].name.toString().trim();
        debtorObj.phone = (this.arrFinalData[iVal].phone === undefined) ? '' : this.arrFinalData[iVal].phone.toString().trim();



        debtorObj.status = (this.arrFinalData[iVal].status === undefined) ? '' : this.arrFinalData[iVal].status.toString();

        customerObj.public_id = this.customerPuplic_key;
        debtorObj.creditor = customerObj;

        addressObj.city = (this.arrFinalData[iVal].city === undefined) ? '' : this.arrFinalData[iVal].city.toString().trim();
        addressObj.street = (this.arrFinalData[iVal].street === undefined) ? '' : this.arrFinalData[iVal].street.toString().trim();
        addressObj.county = (this.arrFinalData[iVal].provice === undefined) ? '' : this.arrFinalData[iVal].provice.toString().trim();
        addressObj.state = (this.arrFinalData[iVal].district === undefined) ? '' : this.arrFinalData[iVal].district.toString().trim();


        debtorObj.address = addressObj;

        const debtorCreatePromiseResult = this.debtorService.createDebtorPromise(debtorObj);

        debtorCreatePromiseResult.then(
            this.successDebtorDetails.bind(this, [debtorObj, iVal])
        )
            .catch(error => {
                this.failureDebtorDetails(error.error, debtorObj, iVal);
            });
    }

    // debtorCreatePromiseResultProcess(arrparams: any, createddebtor: any) {
    //     console.log(createddebtor);
    // }

    failureDebtorDetails(errorValue: any, debtorObj: any, ivalue: any) {
        this.rowNotProcessedCount++;
        this.bindDebtorDetailsExcelData('NO', errorValue, ivalue);
    }

    successDebtorDetails(arrparams: any, createddebtor: any) {
        if (createddebtor.status.toString() == "200") {

            if (createddebtor.body.Error == "500") {
                this.rowNotProcessedCount++;
                this.bindDebtorDetailsExcelData('NO', createddebtor.body.Description, arrparams[1]);
            }
            else {
                this.rowProcessedCount++;
                this.bindDebtorDetailsExcelData('SI', 'La información fue grabada correctamente !', arrparams[1]);
            }
        }
        else if (createddebtor.status.toString() == "201") {
            this.rowProcessedCount++;
            this.bindDebtorDetailsExcelData('SI', 'La información fue grabada correctamente !', arrparams[1]);
        }
    }

    bindDebtorDetailsExcelData(status: any, statusText: any, ivalue: any) {
        var tempDebtorObj = this.arrFinalData[ivalue]
        tempDebtorObj['processed'] = status;
        tempDebtorObj['statustext'] = statusText
        this.arrFinalDataWithStatus.push(tempDebtorObj);
        if (this.arrFinalData.length == this.arrFinalDataWithStatus.length) {
            setTimeout(() => {
                this.spinnerService.hide();
            }, 3000)
        }
    }

    downloadResultAsXLSX() {
        this.setExportExcelFileData(this.arrFinalDataWithStatus);
      }//end
    
    
    
    
    
      setExportExcelFileData(excelExportData) {
        var excelHeader = ['ID CLIENTE', 'DOCUMENTO', 'NUMERO DOCUMENTO', 'NOMBRE', 'EMAIL', 'TELEFONO', 'ESTADO', 'CALLE', 'PROVINCIA', 'CIUDAD', 'DISTRITO', 'PROCESADO', 'PROCESESTADO']
        var jsonObjectKeys = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district', 'processed', 'statustext']
    
        var arrFinalData = [];
        var object_temp = {};
        var i = 0;
        var columnsKeyNames = [];
    
        for (i = 0; i < excelExportData.length-1; i++) {
          var singleRec_temp = excelExportData[i];
          delete singleRec_temp['public_id'];
            
          delete singleRec_temp['item'];
          delete singleRec_temp['dataError'];
          delete singleRec_temp['dataInvalidError'];
          delete singleRec_temp['rowError'];
          columnsKeyNames = Object.keys(singleRec_temp);
          
          object_temp = {};
    
          for (var j = 0; j < columnsKeyNames.length; j++) {
    
            object_temp[excelHeader[j]] = singleRec_temp[jsonObjectKeys[j]];
    
          }
          arrFinalData.push(object_temp);
        }
    
        this.excelService.exportAsExcelFile(arrFinalData, 'ImportedCustomerResult');
    
    
      }

}